/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Tornasol (oct-2026): en escritorio, con la galería apilada ("Stacked"),
  // al elegir un color su foto pasa a ser la primera y se esconden las fotos
  // asignadas a los otros colores. Las fotos generales (GIF, grilla, etc.) se quedan.
  // Sin color elegido (sin ?variant= en la URL) se ven todas, con el GIF primero.
  // No cambia el orden de las fotos en Shopify (la colección sigue mostrando el GIF).
  const originalOrders = new WeakMap();
  const variantMediaCache = new Map();

  function canFilter(productInfo) {
    const images = productInfo.querySelector('product-images');
    return images && !images.hasAttribute('data-fader-desktop') && !window.theme?.isMobile;
  }

  // IDs de las fotos asignadas a alguna variante del producto.
  function getVariantMediaIds(productInfo) {
    const url = productInfo.dataset.url;
    if (!url) return Promise.resolve(new Set());

    if (!variantMediaCache.has(url)) {
      const request = fetch(`${url}.js`)
        .then((response) => response.json())
        .then((product) => new Set(
          product.variants
            .map((variant) => variant.featured_media?.id)
            .filter(Boolean)
            .map(String)
        ))
        .catch(() => new Set());
      variantMediaCache.set(url, request);
    }

    return variantMediaCache.get(url);
  }

  async function showVariantMedia(productInfo, imageId) {
    const list = productInfo.querySelector('[data-product-media-list]');
    if (!list || !imageId || !canFilter(productInfo)) return;

    const slide = list.querySelector(`:scope > [data-image-id="${imageId}"]`);
    if (!slide) return;

    if (!originalOrders.has(list)) {
      originalOrders.set(list, Array.from(list.querySelectorAll(':scope > [data-image-id]')));
    }

    // Primero se reordena (sin esperar) para que el tema haga scroll a la foto ya ubicada arriba.
    originalOrders.get(list).forEach((el) => list.appendChild(el));
    list.prepend(slide);

    const variantMediaIds = await getVariantMediaIds(productInfo);
    if (list.firstElementChild !== slide) return; // ya se eligió otro color

    originalOrders.get(list).forEach((el) => {
      const isOtherVariant = variantMediaIds.has(el.dataset.imageId) && el !== slide;
      el.style.display = isOtherVariant ? 'none' : '';
    });
  }

  // Se piden los datos de las variantes desde el inicio para que el cambio sea inmediato.
  document.querySelectorAll('product-info').forEach((productInfo) => {
    if (canFilter(productInfo)) getVariantMediaIds(productInfo);
  });

  // Si la página abre con ?variant= (por ejemplo desde un swatch), se aplica a ese color.
  if (new URLSearchParams(window.location.search).has('variant')) {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const active = productInfo.querySelector('[data-product-media-list] > .media--active[data-image-id]');
      if (active) showVariantMedia(productInfo, active.dataset.imageId);
    });
  }

  if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const imageId = data?.variant?.featured_media?.id;
      if (!imageId) return;
      document.querySelectorAll('product-info').forEach((productInfo) => showVariantMedia(productInfo, String(imageId)));
    });
  }

  // Si la clienta toca el color que ya venía seleccionado (ej. el primero), el tema no
  // lo toma como cambio; igual se muestra solo ese color.
  let pressedInput = null;
  let pressedWasChecked = false;

  document.addEventListener('pointerdown', (event) => {
    const label = event.target.closest('variant-selects label');
    pressedInput = event.target.closest('variant-selects input[type="radio"]') || label?.control || null;
    pressedWasChecked = Boolean(pressedInput?.checked);
  }, true);

  document.addEventListener('click', (event) => {
    const input = event.target.closest('variant-selects input[type="radio"]');
    const productInfo = input?.closest('product-info');
    if (!productInfo || input !== pressedInput || !pressedWasChecked) return;

    const selected = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
    const imageId = selected ? JSON.parse(selected)?.featured_media?.id : null;
    const list = productInfo.querySelector('[data-product-media-list]');
    if (!imageId || !list || list.firstElementChild?.dataset.imageId === String(imageId)) return;

    showVariantMedia(productInfo, String(imageId)).then(() => {
      const top = productInfo.querySelector('product-images')?.getBoundingClientRect().top;
      if (top < 0) window.theme?.scrollTo?.(top);
    });
  });

  // Tornasol (oct-2026): botón "Avísame cuando esté disponible".
  // Además del correo que el tema manda a contacto@, la clienta queda suscrita al
  // aviso de reposición de Klaviyo para esa variante. Klaviyo le escribe sola
  // cuando el stock vuelve (flujo "Back in Stock" de Klaviyo).
  const KLAVIYO_COMPANY_ID = 'UmgsMR';

  function notificationVariantId(form) {
    const selected = (form.closest('product-info') || document)
      .querySelector('variant-selects [data-selected-variant]')?.textContent;
    const fromSelected = selected ? JSON.parse(selected)?.id : null;
    return String(
      fromSelected ||
      form.dataset.variantId ||
      new URLSearchParams(window.location.search).get('variant') ||
      form.id.split('--').pop()
    );
  }

  function subscribeBackInStock(email, variantId) {
    return fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email } } },
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } },
          },
        },
      }),
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-notification-form]');
    if (!form || form.dataset.klaviyoSent) return;

    const email = form.querySelector('input[type="email"]')?.value.trim();
    const variantId = notificationVariantId(form);
    if (!email || !/^\d+$/.test(variantId)) return;

    // Se espera a Klaviyo (máx. 4 s) y luego el formulario sigue como siempre.
    event.preventDefault();
    form.dataset.klaviyoSent = 'true';
    const timeout = new Promise((resolve) => setTimeout(resolve, 4000));
    Promise.race([subscribeBackInStock(email, variantId).catch(() => {}), timeout])
      .then(() => form.submit());
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
